module.exports = __webpack_public_path__ + "static/media/img1.f5bd5e7a.jpg";